var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDrawerArrowIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5297 14.1375L6.15469 9.6375M6.15469 9.6375L10.5297 5.1375M6.15469 9.6375H16.9547M2.55469 2.4375V16.8375",
    stroke: "#87888D",
    strokeWidth: 1.5579,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDrawerArrowIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/DrawerArrowIcon.b91a0a00.svg";
export { ForwardRef as ReactComponent };